/**
 * Geometry of the authenticated app shell (sidebar + content offset).
 *
 * The sidebar is `position: fixed`, so its width and the content's left offset are
 * two numbers that must agree exactly — a mismatch does not shift the layout, it
 * puts the sidebar ON TOP of the content. They lived in two files and drifted by
 * 8px; keeping them here is what makes that drift a type error instead of a
 * silent overlap.
 *
 * @module @shared/constants
 */

export const APP_SIDEBAR_WIDTH = {
  expanded: 264,
  collapsed: 80,
  /** Drawer width on phones; the shell reserves no offset for it (it overlays). */
  mobile: 260,
} as const;

/**
 * Viewport tiers for the shell. `tabletPortrait` exists because a 768px-wide
 * iPad gives the desktop rail 34% of the screen — wide enough to break content,
 * too wide to ignore, and it is not a phone (no hamburger-only navigation).
 */
/** Ease-out-quint: fast departure, long settle, so the panel reads as pulled. */
export const APP_SIDEBAR_EASE = [0.22, 1, 0.36, 1] as const;
export const APP_SIDEBAR_DURATION = 0.32;

export const APP_SHELL_BREAKPOINT = {
  /** Below this: phone — sidebar becomes an overlay drawer. */
  mobile: 768,
  /** Below this (and at/above `mobile`): tablet portrait — rail forced collapsed. */
  desktop: 1024,
} as const;

export type AppViewportTier = 'mobile' | 'tabletPortrait' | 'desktop';
